export const isRootieComponent = (component: any) => {
  const result = component.Component !== undefined && typeof component.Component === 'function';
  return result;
}
